import React, { useEffect, useState } from 'react'
import { Layout, Menu } from 'antd'
import { MenuStyle } from './style';
import {
  PieChartOutlined,
  FileTextOutlined,
  UserDeleteOutlined
} from '@ant-design/icons';
import { IMenuItem } from 'model';
import { useDispatch, useSelector } from 'react-redux';
import { setBreadcrumbState } from 'store/slice/title';
import { RootState } from 'store';
import { useNavigate } from 'react-router-dom';
interface Props{
  menuList: Array<IMenuItem>
}
const { SubMenu } = Menu;
const { Sider } = Layout
const MenuPage = (props: Props) => {
  const dispatch = useDispatch()
  const { menuList } = props
  const [defaultOpenKeys , setDefaultOpenKeys] =  useState<string>('');
  const [defaultKeys , setDefaultKeys] =  useState<string>('');
  const [openKeys , setOpenKeys] =  useState<string>('');
  const [selectedKeys , setSelectedKeys] =  useState<string>('');
  const iconfont = [<PieChartOutlined />, <FileTextOutlined />, <UserDeleteOutlined />];
  const breadcrumb = useSelector((state: RootState) => state.breadcrumbSlice)
  let navigator = useNavigate()
  useEffect(() => {
    const sessionSelectedKeys = sessionStorage.getItem('selectedKeys')
    const sessionOpenKeys = sessionStorage.getItem('openKeys')
    if(!menuList.length) return
    if(sessionSelectedKeys){
      setSelectedKeys(sessionSelectedKeys)
      setDefaultKeys(sessionSelectedKeys)
    }else {
      setDefaultKeys(menuList[0].menuVOS[0].id)
      setSelectedKeys(menuList[0].menuVOS[0].id)
    }
    if(sessionOpenKeys){
      setOpenKeys(sessionOpenKeys)
      setDefaultOpenKeys(sessionOpenKeys)
    }else {
      setOpenKeys(menuList[0].id)
      setDefaultOpenKeys(menuList[0].id)
    }
  }, [menuList])

  const onMenuClick= (menu, child) => {
    navigator(child.url);
    let txt: string = '';
    txt = menu.name + ' / ' + child.name
    setSelectedKeys(child.id)
    sessionStorage.setItem('selectedKeys', child.id);
    dispatch(setBreadcrumbState({ title: breadcrumb.title, menuName: txt}))
  }

  const onTitleClick = (val) => {
    if(val.key === openKeys){
      setOpenKeys('')
      sessionStorage.setItem('openKeys', '');
    } else {
      for (const iterator of menuList) {
        if(val.key === iterator.id) {
          setOpenKeys(val.key)
          sessionStorage.setItem('openKeys', val.key);
        }
      }
    }
  }

  return (
    <MenuStyle>
      <Sider width={200} className="site-layout-background">
      {
        defaultOpenKeys && defaultKeys ? (
          <Menu
            mode="inline"
            defaultSelectedKeys={[defaultKeys]}
            defaultOpenKeys={[defaultOpenKeys]}
            openKeys={[openKeys]}
            selectedKeys={[selectedKeys]}
            style={{ height: '100%', borderRight: 0 }}
          >
            {menuList?.map((menu,index) =>
              menu.menuVOS ? (
                <SubMenu key={menu.id} icon={iconfont[index]} title={menu.name} onTitleClick={onTitleClick}>
                  {menu.menuVOS.map(child => (
                    <Menu.Item key={child.id} onClick={() => onMenuClick(menu, child)}>
                      {child.name}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={menu.id}>
                  {menu.name}
                </Menu.Item>
              )
            )}
          </Menu>
        ): ''
      }
    </Sider>
    </MenuStyle>
  )
}

export default MenuPage;
